import styled, { css } from 'styled-components'
import theme from 'live/services/theme'
import LiveCardContainer, { ControlButton } from 'live/components/ui/CardContainer'

export const CardContainer = styled(LiveCardContainer)`
    position: relative;
    padding: 0;
    ${props =>
        props.fullscreen &&
        css`
            position: fixed;
            top: 55px;
            left: 8px;
            background-color: #fff;
            height: calc(100% - 90px);
            width: calc(100% - 20px);
            overflow: auto;
            z-index: 200;
            transform: translate(100% - 90px, 100% - 40px);
        `}
    header {
        z-index: 3;
        padding: 18px;
        height: 54px;
        > div {
            font-size: 16px !important;
        }
        user-select: none;
    }
    ${ControlButton} {
        span {
            margin-right: 4px;
        }
    }

    .search-bar {
        position: sticky;
        top: 54px;
        z-index: 3;
    }
`

export const TableContainer = styled.div`
    .table-row {
        cursor: pointer;
        &:hover {
            .ellipsis-dropdown {
                button {
                    color: ${theme['link-color']};
                }
            }
        }
    }

    .ellipsis-dropdown {
        button {
            color: transparent;
        }
    }
`


export const LeftSideControlsContainer = styled.div`
    display: flex;
    margin-right: auto;
    i {
        margin-right: 8px;
        font-size: 14px;
    }
    span {
        font-size: 13px;
    }
`

export const RightSideControlsContainer = styled.div`
    display: flex;
    ${ControlButton} {
        margin-left: 30px;
        & > div {
            display: flex;
        }
        .fa-plus-circle {
            font-size: 16px;
        }
    }
`

export const FinishSelectionButton = styled.div`
    color: ${theme.warn};
    i {
        vertical-align: top;
        font-size: 16px;
        line-height: 16px;
    }
`
export const ControlButtonDelete = styled(ControlButton)`
    color: ${theme['brand-danger']};
`
export const ControlButtonEdit = styled(ControlButton)`
    color: rgb(55, 163, 239);
    margin-left: 15px;
`

export const Separator = styled.div`
    width: 1px;
    height: 28px;
    background-color: ${theme['dash-background']};
    margin-right: 20px;
    margin-left: 17px;
`
